import { FC, ReactNode, useLayoutEffect } from "react";
import { SvgIcon, useTheme } from "@mui/material";
import CopyrightIcon from "@mui/icons-material/Copyright";
import PoweredByOneHealth from "../../assets/1health-logo-powered-by-gray.svg?react";

import { classes, StyledBox } from "./GenericPublicPageWrapperStyles";
import useContentEnterTransition, { PAGE_TRANSITION } from "../../Hooks/useContentEnterTransition";

interface GenericPublicPageWrapperProps {
    /**
     * The page content. Still called `right` from when this shell had a left branding column;
     * NG-8572 removed that column from every public page, so this is now the only slot.
     */
    right: ReactNode;
    /** Shortens the viewport to make room for the "Powered by 1Health" strip on tenant subdomains. */
    isSubdomain?: boolean;
}

const GenericPublicPageWrapper: FC<GenericPublicPageWrapperProps> = ({ right, isSubdomain }) => {
    const theme = useTheme();
    useLayoutEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // The same page entrance the authenticated layout runs. Mount is the trigger rather than the
    // route: public pages are separate components, so moving between /login and /register unmounts
    // one shell and mounts the next — unlike MainLayout, which survives every navigation.
    const contentRef = useContentEnterTransition<HTMLDivElement>(null, PAGE_TRANSITION);

    return (
        <StyledBox className={classes.pageWrapper} isSubdomain={isSubdomain}>
            <div className={classes.rightSidePageWrapper}>
                <div ref={contentRef} className={classes.pageContent}>
                    {right}
                </div>
            </div>
            {isSubdomain && (
                <div
                    style={{
                        width: "100%",
                        height: "5vh",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end",
                        backgroundColor: theme.palette.background.paper,
                    }}
                >
                    <SvgIcon component={PoweredByOneHealth} inheritViewBox sx={{ width: "175px" }} />
                    <CopyrightIcon sx={{ fontSize: "1.2em", fontVariantPosition: "super", marginLeft: "3px" }} />
                </div>
            )}
        </StyledBox>
    );
};

export default GenericPublicPageWrapper;
